export interface WCTeam {
  id: string;
  name: string;
  flag: string;
  cc: string;
  fifaRank: number;
  group: string;
}

export function getFlagUrl(cc: string): string {
  return `https://flagcdn.com/20x15/${cc}.png`;
}

export interface WCMatch {
  id: string;
  groupId: string;
  homeTeamId: string;
  awayTeamId: string;
  matchday: number;
  date: string;        // YYYY-MM-DD local date (for display)
  kickoff?: string;    // Full UTC ISO datetime, e.g. "2026-06-11T19:00:00Z"
  venue?: string;      // Stadium, City
  result?: "H" | "D" | "A";
  homeScore?: number;
  awayScore?: number;
  isFinished: boolean;
}

export interface WCGroupStanding {
  teamId: string;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  goalsFor: number;
  goalsAgainst: number;
  gd: number;
  points: number;
  position: number;
}

// FIFA World Cup 2026 — Official draw (Dec 5 2024). Hosts: Mexico (A), Canada (B), USA (D).
export const WC_TEAMS: WCTeam[] = [
  // Group A — Host: Mexico
  { id: "MEX", name: "Mexico",       flag: "🇲🇽", cc: "mx", fifaRank: 15, group: "A" },
  { id: "RSA", name: "South Africa", flag: "🇿🇦", cc: "za", fifaRank: 63, group: "A" },
  { id: "KOR", name: "South Korea",  flag: "🇰🇷", cc: "kr", fifaRank: 22, group: "A" },
  { id: "CZE", name: "Czechia",      flag: "🇨🇿", cc: "cz", fifaRank: 37, group: "A" },
  // Group B — Host: Canada
  { id: "CAN", name: "Canada",             flag: "🇨🇦", cc: "ca", fifaRank: 47, group: "B" },
  { id: "BIH", name: "Bosnia & Herzegovina", flag: "🇧🇦", cc: "ba", fifaRank: 55, group: "B" },
  { id: "QAT", name: "Qatar",              flag: "🇶🇦", cc: "qa", fifaRank: 37, group: "B" },
  { id: "SUI", name: "Switzerland",        flag: "🇨🇭", cc: "ch", fifaRank: 19, group: "B" },
  // Group C
  { id: "BRA", name: "Brazil",    flag: "🇧🇷", cc: "br", fifaRank: 5,  group: "C" },
  { id: "MAR", name: "Morocco",   flag: "🇲🇦", cc: "ma", fifaRank: 14, group: "C" },
  { id: "HAI", name: "Haiti",     flag: "🇭🇹", cc: "ht", fifaRank: 91, group: "C" },
  { id: "SCO", name: "Scotland",  flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", cc: "gb-sct", fifaRank: 30, group: "C" },
  // Group D — Host: USA
  { id: "USA", name: "United States", flag: "🇺🇸", cc: "us", fifaRank: 11, group: "D" },
  { id: "PAR", name: "Paraguay",      flag: "🇵🇾", cc: "py", fifaRank: 60, group: "D" },
  { id: "AUS", name: "Australia",     flag: "🇦🇺", cc: "au", fifaRank: 23, group: "D" },
  { id: "TUR", name: "Türkiye",       flag: "🇹🇷", cc: "tr", fifaRank: 26, group: "D" },
  // Group E
  { id: "GER", name: "Germany",       flag: "🇩🇪", cc: "de", fifaRank: 9,  group: "E" },
  { id: "CUW", name: "Curaçao",       flag: "🇨🇼", cc: "cw", fifaRank: 88, group: "E" },
  { id: "CIV", name: "Côte d'Ivoire", flag: "🇨🇮", cc: "ci", fifaRank: 48, group: "E" },
  { id: "ECU", name: "Ecuador",       flag: "🇪🇨", cc: "ec", fifaRank: 44, group: "E" },
  // Group F
  { id: "NED", name: "Netherlands", flag: "🇳🇱", cc: "nl", fifaRank: 7,  group: "F" },
  { id: "JPN", name: "Japan",       flag: "🇯🇵", cc: "jp", fifaRank: 17, group: "F" },
  { id: "SWE", name: "Sweden",      flag: "🇸🇪", cc: "se", fifaRank: 24, group: "F" },
  { id: "TUN", name: "Tunisia",     flag: "🇹🇳", cc: "tn", fifaRank: 30, group: "F" },
  // Group G
  { id: "BEL", name: "Belgium",     flag: "🇧🇪", cc: "be", fifaRank: 3,  group: "G" },
  { id: "IRN", name: "Iran",        flag: "🇮🇷", cc: "ir", fifaRank: 22, group: "G" },
  { id: "EGY", name: "Egypt",       flag: "🇪🇬", cc: "eg", fifaRank: 38, group: "G" },
  { id: "NZL", name: "New Zealand", flag: "🇳🇿", cc: "nz", fifaRank: 99, group: "G" },
  // Group H
  { id: "ESP", name: "Spain",       flag: "🇪🇸", cc: "es", fifaRank: 6,  group: "H" },
  { id: "SAU", name: "Saudi Arabia", flag: "🇸🇦", cc: "sa", fifaRank: 57, group: "H" },
  { id: "URU", name: "Uruguay",     flag: "🇺🇾", cc: "uy", fifaRank: 18, group: "H" },
  { id: "CPV", name: "Cape Verde",  flag: "🇨🇻", cc: "cv", fifaRank: 78, group: "H" },
  // Group I
  { id: "FRA", name: "France",  flag: "🇫🇷", cc: "fr", fifaRank: 2,  group: "I" },
  { id: "SEN", name: "Senegal", flag: "🇸🇳", cc: "sn", fifaRank: 20, group: "I" },
  { id: "IRQ", name: "Iraq",    flag: "🇮🇶", cc: "iq", fifaRank: 56, group: "I" },
  { id: "NOR", name: "Norway",  flag: "🇳🇴", cc: "no", fifaRank: 34, group: "I" },
  // Group J
  { id: "ARG", name: "Argentina", flag: "🇦🇷", cc: "ar", fifaRank: 1,  group: "J" },
  { id: "ALG", name: "Algeria",   flag: "🇩🇿", cc: "dz", fifaRank: 50, group: "J" },
  { id: "AUT", name: "Austria",   flag: "🇦🇹", cc: "at", fifaRank: 25, group: "J" },
  { id: "JOR", name: "Jordan",    flag: "🇯🇴", cc: "jo", fifaRank: 85, group: "J" },
  // Group K
  { id: "POR", name: "Portugal",  flag: "🇵🇹", cc: "pt", fifaRank: 6,  group: "K" },
  { id: "COD", name: "DR Congo",  flag: "🇨🇩", cc: "cd", fifaRank: 56, group: "K" },
  { id: "UZB", name: "Uzbekistan", flag: "🇺🇿", cc: "uz", fifaRank: 70, group: "K" },
  { id: "COL", name: "Colombia",  flag: "🇨🇴", cc: "co", fifaRank: 25, group: "K" },
  // Group L
  { id: "ENG", name: "England",  flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", cc: "gb-eng", fifaRank: 4,  group: "L" },
  { id: "CRO", name: "Croatia",  flag: "🇭🇷", cc: "hr", fifaRank: 10, group: "L" },
  { id: "GHA", name: "Ghana",    flag: "🇬🇭", cc: "gh", fifaRank: 60, group: "L" },
  { id: "PAN", name: "Panama",   flag: "🇵🇦", cc: "pa", fifaRank: 80, group: "L" },
];

export const WC_GROUPS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"] as const;

// All times in UTC. ET = UTC−4 in summer 2026. CDT (Mexico) = UTC−5.
// Source: Official ESPN/FIFA schedule published Dec 6 2025.
// All kickoff times converted from Eastern Time (ET) unless noted.
export const WC_MATCHES: WCMatch[] = [
  // ── GROUP A (MEX host) ──────────────────────────────────────────────────────
  { id:"A-1", groupId:"A", homeTeamId:"MEX", awayTeamId:"RSA", matchday:1, date:"2026-06-11", kickoff:"2026-06-11T19:00:00Z", venue:"Estadio Azteca, Mexico City",           isFinished:false }, // MD1 3pm ET ✅
  { id:"A-2", groupId:"A", homeTeamId:"KOR", awayTeamId:"CZE", matchday:1, date:"2026-06-11", kickoff:"2026-06-12T02:00:00Z", venue:"Estadio Akron, Guadalajara",             isFinished:false }, // MD1 10pm ET ✅
  { id:"A-3", groupId:"A", homeTeamId:"CZE", awayTeamId:"RSA", matchday:2, date:"2026-06-18", kickoff:"2026-06-18T16:00:00Z", venue:"Mercedes-Benz Stadium, Atlanta",         isFinished:false }, // MD2 12pm ET ✅
  { id:"A-4", groupId:"A", homeTeamId:"MEX", awayTeamId:"KOR", matchday:2, date:"2026-06-18", kickoff:"2026-06-19T01:00:00Z", venue:"Estadio Akron, Guadalajara",             isFinished:false }, // MD2 9pm ET
  { id:"A-5", groupId:"A", homeTeamId:"CZE", awayTeamId:"MEX", matchday:3, date:"2026-06-24", kickoff:"2026-06-25T02:00:00Z", venue:"Estadio Azteca, Mexico City",            isFinished:false }, // MD3 9pm ET simultaneous
  { id:"A-6", groupId:"A", homeTeamId:"RSA", awayTeamId:"KOR", matchday:3, date:"2026-06-24", kickoff:"2026-06-25T02:00:00Z", venue:"Estadio BBVA, Monterrey",                isFinished:false }, // MD3 9pm ET simultaneous

  // ── GROUP B (CAN host) ──────────────────────────────────────────────────────
  { id:"B-1", groupId:"B", homeTeamId:"CAN", awayTeamId:"BIH", matchday:1, date:"2026-06-12", kickoff:"2026-06-12T19:00:00Z", venue:"BMO Field, Toronto",                    isFinished:false }, // MD1 3pm ET ✅
  { id:"B-2", groupId:"B", homeTeamId:"QAT", awayTeamId:"SUI", matchday:1, date:"2026-06-13", kickoff:"2026-06-13T19:00:00Z", venue:"Levi's Stadium, Santa Clara",            isFinished:false }, // MD1 3pm ET ✅
  { id:"B-3", groupId:"B", homeTeamId:"SUI", awayTeamId:"BIH", matchday:2, date:"2026-06-18", kickoff:"2026-06-18T19:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD2 3pm ET ✅
  { id:"B-4", groupId:"B", homeTeamId:"CAN", awayTeamId:"QAT", matchday:2, date:"2026-06-18", kickoff:"2026-06-18T22:00:00Z", venue:"BC Place, Vancouver",                   isFinished:false }, // MD2 6pm ET ✅
  { id:"B-5", groupId:"B", homeTeamId:"SUI", awayTeamId:"CAN", matchday:3, date:"2026-06-24", kickoff:"2026-06-24T19:00:00Z", venue:"BC Place, Vancouver",                   isFinished:false }, // MD3 3pm ET simultaneous
  { id:"B-6", groupId:"B", homeTeamId:"BIH", awayTeamId:"QAT", matchday:3, date:"2026-06-24", kickoff:"2026-06-24T19:00:00Z", venue:"Levi's Stadium, Santa Clara",           isFinished:false }, // MD3 3pm ET simultaneous

  // ── GROUP C ─────────────────────────────────────────────────────────────────
  { id:"C-1", groupId:"C", homeTeamId:"BRA", awayTeamId:"MAR", matchday:1, date:"2026-06-13", kickoff:"2026-06-13T22:00:00Z", venue:"MetLife Stadium, New Jersey",            isFinished:false }, // MD1 6pm ET ✅
  { id:"C-2", groupId:"C", homeTeamId:"HAI", awayTeamId:"SCO", matchday:1, date:"2026-06-13", kickoff:"2026-06-14T01:00:00Z", venue:"Gillette Stadium, Foxborough",           isFinished:false }, // MD1 9pm ET (Haiti listed first/home)
  { id:"C-3", groupId:"C", homeTeamId:"SCO", awayTeamId:"MAR", matchday:2, date:"2026-06-19", kickoff:"2026-06-19T22:00:00Z", venue:"Gillette Stadium, Foxborough",           isFinished:false }, // MD2 6pm ET
  { id:"C-4", groupId:"C", homeTeamId:"BRA", awayTeamId:"HAI", matchday:2, date:"2026-06-19", kickoff:"2026-06-20T01:00:00Z", venue:"Lincoln Financial Field, Philadelphia",  isFinished:false }, // MD2 9pm ET
  { id:"C-5", groupId:"C", homeTeamId:"SCO", awayTeamId:"BRA", matchday:3, date:"2026-06-24", kickoff:"2026-06-24T22:00:00Z", venue:"Hard Rock Stadium, Miami",               isFinished:false }, // MD3 6pm ET simultaneous
  { id:"C-6", groupId:"C", homeTeamId:"MAR", awayTeamId:"HAI", matchday:3, date:"2026-06-24", kickoff:"2026-06-24T22:00:00Z", venue:"Mercedes-Benz Stadium, Atlanta",         isFinished:false }, // MD3 6pm ET simultaneous

  // ── GROUP D (USA host) ──────────────────────────────────────────────────────
  { id:"D-1", groupId:"D", homeTeamId:"USA", awayTeamId:"PAR", matchday:1, date:"2026-06-12", kickoff:"2026-06-13T01:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD1 9pm ET ✅
  { id:"D-2", groupId:"D", homeTeamId:"AUS", awayTeamId:"TUR", matchday:1, date:"2026-06-13", kickoff:"2026-06-14T04:00:00Z", venue:"BC Place, Vancouver",                   isFinished:false }, // MD1 midnight ET
  { id:"D-3", groupId:"D", homeTeamId:"USA", awayTeamId:"AUS", matchday:2, date:"2026-06-19", kickoff:"2026-06-19T19:00:00Z", venue:"Lumen Field, Seattle",                  isFinished:false }, // MD2 3pm ET ✅
  { id:"D-4", groupId:"D", homeTeamId:"TUR", awayTeamId:"PAR", matchday:2, date:"2026-06-19", kickoff:"2026-06-20T01:00:00Z", venue:"Levi's Stadium, Santa Clara",           isFinished:false }, // MD2 9pm ET ✅
  { id:"D-5", groupId:"D", homeTeamId:"TUR", awayTeamId:"USA", matchday:3, date:"2026-06-25", kickoff:"2026-06-26T02:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD3 10pm ET simultaneous (TUR listed home)
  { id:"D-6", groupId:"D", homeTeamId:"PAR", awayTeamId:"AUS", matchday:3, date:"2026-06-25", kickoff:"2026-06-26T02:00:00Z", venue:"Levi's Stadium, Santa Clara",           isFinished:false }, // MD3 10pm ET simultaneous

  // ── GROUP E ─────────────────────────────────────────────────────────────────
  { id:"E-1", groupId:"E", homeTeamId:"GER", awayTeamId:"CUW", matchday:1, date:"2026-06-14", kickoff:"2026-06-14T17:00:00Z", venue:"NRG Stadium, Houston",                  isFinished:false }, // MD1 1pm ET ✅
  { id:"E-2", groupId:"E", homeTeamId:"CIV", awayTeamId:"ECU", matchday:1, date:"2026-06-14", kickoff:"2026-06-14T23:00:00Z", venue:"Lincoln Financial Field, Philadelphia",  isFinished:false }, // MD1 7pm ET ✅
  { id:"E-3", groupId:"E", homeTeamId:"GER", awayTeamId:"CIV", matchday:2, date:"2026-06-20", kickoff:"2026-06-20T19:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD2 3pm ET ✅
  { id:"E-4", groupId:"E", homeTeamId:"CUW", awayTeamId:"ECU", matchday:2, date:"2026-06-20", kickoff:"2026-06-20T22:00:00Z", venue:"NRG Stadium, Houston",                  isFinished:false }, // MD2 6pm ET ✅
  { id:"E-5", groupId:"E", homeTeamId:"ECU", awayTeamId:"GER", matchday:3, date:"2026-06-25", kickoff:"2026-06-25T20:00:00Z", venue:"MetLife Stadium, New Jersey",           isFinished:false }, // MD3 4pm ET simultaneous (ECU listed home)
  { id:"E-6", groupId:"E", homeTeamId:"CUW", awayTeamId:"CIV", matchday:3, date:"2026-06-25", kickoff:"2026-06-25T20:00:00Z", venue:"Lincoln Financial Field, Philadelphia",  isFinished:false }, // MD3 4pm ET simultaneous

  // ── GROUP F ─────────────────────────────────────────────────────────────────
  { id:"F-1", groupId:"F", homeTeamId:"NED", awayTeamId:"JPN", matchday:1, date:"2026-06-14", kickoff:"2026-06-14T20:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD1 4pm ET ✅
  { id:"F-2", groupId:"F", homeTeamId:"SWE", awayTeamId:"TUN", matchday:1, date:"2026-06-14", kickoff:"2026-06-15T02:00:00Z", venue:"Estadio Akron, Guadalajara",             isFinished:false }, // MD1 10pm ET
  { id:"F-3", groupId:"F", homeTeamId:"NED", awayTeamId:"SWE", matchday:2, date:"2026-06-21", kickoff:"2026-06-21T17:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD2 1pm ET ✅
  { id:"F-4", groupId:"F", homeTeamId:"JPN", awayTeamId:"TUN", matchday:2, date:"2026-06-21", kickoff:"2026-06-21T20:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD2 4pm ET ✅
  { id:"F-5", groupId:"F", homeTeamId:"TUN", awayTeamId:"NED", matchday:3, date:"2026-06-25", kickoff:"2026-06-25T23:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD3 7pm ET simultaneous (TUN listed home)
  { id:"F-6", groupId:"F", homeTeamId:"JPN", awayTeamId:"SWE", matchday:3, date:"2026-06-25", kickoff:"2026-06-25T23:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD3 7pm ET simultaneous

  // ── GROUP G ─────────────────────────────────────────────────────────────────
  { id:"G-1", groupId:"G", homeTeamId:"BEL", awayTeamId:"EGY", matchday:1, date:"2026-06-15", kickoff:"2026-06-15T19:00:00Z", venue:"Lumen Field, Seattle",                  isFinished:false }, // MD1 3pm ET
  { id:"G-2", groupId:"G", homeTeamId:"IRN", awayTeamId:"NZL", matchday:1, date:"2026-06-15", kickoff:"2026-06-16T04:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD1 midnight ET ✅
  { id:"G-3", groupId:"G", homeTeamId:"BEL", awayTeamId:"IRN", matchday:2, date:"2026-06-21", kickoff:"2026-06-21T19:00:00Z", venue:"SoFi Stadium, Inglewood",               isFinished:false }, // MD2 3pm ET
  { id:"G-4", groupId:"G", homeTeamId:"NZL", awayTeamId:"EGY", matchday:2, date:"2026-06-21", kickoff:"2026-06-22T01:00:00Z", venue:"BC Place, Vancouver",                   isFinished:false }, // MD2 9pm ET
  { id:"G-5", groupId:"G", homeTeamId:"EGY", awayTeamId:"IRN", matchday:3, date:"2026-06-26", kickoff:"2026-06-27T03:00:00Z", venue:"Lumen Field, Seattle",                  isFinished:false }, // MD3 11pm ET simultaneous
  { id:"G-6", groupId:"G", homeTeamId:"NZL", awayTeamId:"BEL", matchday:3, date:"2026-06-26", kickoff:"2026-06-27T03:00:00Z", venue:"BC Place, Vancouver",                   isFinished:false }, // MD3 11pm ET simultaneous

  // ── GROUP H ─────────────────────────────────────────────────────────────────
  { id:"H-1", groupId:"H", homeTeamId:"ESP", awayTeamId:"CPV", matchday:1, date:"2026-06-15", kickoff:"2026-06-15T16:00:00Z", venue:"Mercedes-Benz Stadium, Atlanta",        isFinished:false }, // MD1 12pm ET
  { id:"H-2", groupId:"H", homeTeamId:"SAU", awayTeamId:"URU", matchday:1, date:"2026-06-15", kickoff:"2026-06-15T22:00:00Z", venue:"Hard Rock Stadium, Miami",               isFinished:false }, // MD1 6pm ET ✅
  { id:"H-3", groupId:"H", homeTeamId:"ESP", awayTeamId:"SAU", matchday:2, date:"2026-06-21", kickoff:"2026-06-21T16:00:00Z", venue:"Mercedes-Benz Stadium, Atlanta",        isFinished:false }, // MD2 12pm ET ✅
  { id:"H-4", groupId:"H", homeTeamId:"URU", awayTeamId:"CPV", matchday:2, date:"2026-06-21", kickoff:"2026-06-21T22:00:00Z", venue:"Hard Rock Stadium, Miami",               isFinished:false }, // MD2 6pm ET
  { id:"H-5", groupId:"H", homeTeamId:"ESP", awayTeamId:"URU", matchday:3, date:"2026-06-26", kickoff:"2026-06-27T00:00:00Z", venue:"Hard Rock Stadium, Miami",               isFinished:false }, // MD3 8pm ET simultaneous
  { id:"H-6", groupId:"H", homeTeamId:"CPV", awayTeamId:"SAU", matchday:3, date:"2026-06-26", kickoff:"2026-06-27T00:00:00Z", venue:"NRG Stadium, Houston",                  isFinished:false }, // MD3 8pm ET simultaneous (CPV listed home)

  // ── GROUP I ─────────────────────────────────────────────────────────────────
  { id:"I-1", groupId:"I", homeTeamId:"FRA", awayTeamId:"SEN", matchday:1, date:"2026-06-16", kickoff:"2026-06-16T19:00:00Z", venue:"MetLife Stadium, New Jersey",            isFinished:false }, // MD1 3pm ET ✅
  { id:"I-2", groupId:"I", homeTeamId:"IRQ", awayTeamId:"NOR", matchday:1, date:"2026-06-16", kickoff:"2026-06-16T22:00:00Z", venue:"Gillette Stadium, Foxborough",           isFinished:false }, // MD1 6pm ET ✅
  { id:"I-3", groupId:"I", homeTeamId:"FRA", awayTeamId:"IRQ", matchday:2, date:"2026-06-22", kickoff:"2026-06-22T22:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD2 6pm ET ✅
  { id:"I-4", groupId:"I", homeTeamId:"SEN", awayTeamId:"NOR", matchday:2, date:"2026-06-23", kickoff:"2026-06-23T01:00:00Z", venue:"Lincoln Financial Field, Philadelphia",  isFinished:false }, // MD2 9pm ET ✅
  { id:"I-5", groupId:"I", homeTeamId:"NOR", awayTeamId:"FRA", matchday:3, date:"2026-06-26", kickoff:"2026-06-26T19:00:00Z", venue:"Gillette Stadium, Foxborough",           isFinished:false }, // MD3 3pm ET simultaneous (NOR listed home)
  { id:"I-6", groupId:"I", homeTeamId:"SEN", awayTeamId:"IRQ", matchday:3, date:"2026-06-26", kickoff:"2026-06-26T19:00:00Z", venue:"BMO Field, Toronto",                    isFinished:false }, // MD3 3pm ET simultaneous

  // ── GROUP J ─────────────────────────────────────────────────────────────────
  { id:"J-1", groupId:"J", homeTeamId:"ARG", awayTeamId:"ALG", matchday:1, date:"2026-06-16", kickoff:"2026-06-17T01:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD1 9pm ET ✅
  { id:"J-2", groupId:"J", homeTeamId:"AUT", awayTeamId:"JOR", matchday:1, date:"2026-06-16", kickoff:"2026-06-17T04:00:00Z", venue:"Levi's Stadium, Santa Clara",           isFinished:false }, // MD1 midnight ET
  { id:"J-3", groupId:"J", homeTeamId:"ARG", awayTeamId:"AUT", matchday:2, date:"2026-06-23", kickoff:"2026-06-23T19:00:00Z", venue:"Mercedes-Benz Stadium, Atlanta",        isFinished:false }, // MD2 3pm ET ✅
  { id:"J-4", groupId:"J", homeTeamId:"ALG", awayTeamId:"JOR", matchday:2, date:"2026-06-23", kickoff:"2026-06-23T22:00:00Z", venue:"Lumen Field, Seattle",                  isFinished:false }, // MD2 6pm ET ✅
  { id:"J-5", groupId:"J", homeTeamId:"JOR", awayTeamId:"ARG", matchday:3, date:"2026-06-27", kickoff:"2026-06-28T02:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD3 10pm ET simultaneous (JOR listed home)
  { id:"J-6", groupId:"J", homeTeamId:"ALG", awayTeamId:"AUT", matchday:3, date:"2026-06-27", kickoff:"2026-06-28T02:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD3 10pm ET simultaneous

  // ── GROUP K ─────────────────────────────────────────────────────────────────
  { id:"K-1", groupId:"K", homeTeamId:"POR", awayTeamId:"COD", matchday:1, date:"2026-06-17", kickoff:"2026-06-17T17:00:00Z", venue:"NRG Stadium, Houston",                  isFinished:false }, // MD1 1pm ET ✅
  { id:"K-2", groupId:"K", homeTeamId:"UZB", awayTeamId:"COL", matchday:1, date:"2026-06-17", kickoff:"2026-06-18T02:00:00Z", venue:"Estadio Azteca, Mexico City",            isFinished:false }, // MD1 10pm ET ✅
  { id:"K-3", groupId:"K", homeTeamId:"POR", awayTeamId:"UZB", matchday:2, date:"2026-06-24", kickoff:"2026-06-24T17:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD2 1pm ET ✅
  { id:"K-4", groupId:"K", homeTeamId:"COD", awayTeamId:"COL", matchday:2, date:"2026-06-24", kickoff:"2026-06-24T20:00:00Z", venue:"Levi's Stadium, Santa Clara",           isFinished:false }, // MD2 4pm ET ✅
  { id:"K-5", groupId:"K", homeTeamId:"POR", awayTeamId:"COL", matchday:3, date:"2026-06-27", kickoff:"2026-06-27T23:30:00Z", venue:"NRG Stadium, Houston",                  isFinished:false }, // MD3 7:30pm ET simultaneous
  { id:"K-6", groupId:"K", homeTeamId:"COD", awayTeamId:"UZB", matchday:3, date:"2026-06-27", kickoff:"2026-06-27T23:30:00Z", venue:"Mercedes-Benz Stadium, Atlanta",        isFinished:false }, // MD3 7:30pm ET simultaneous

  // ── GROUP L ─────────────────────────────────────────────────────────────────
  { id:"L-1", groupId:"L", homeTeamId:"ENG", awayTeamId:"CRO", matchday:1, date:"2026-06-17", kickoff:"2026-06-17T20:00:00Z", venue:"AT&T Stadium, Arlington",               isFinished:false }, // MD1 4pm ET ✅
  { id:"L-2", groupId:"L", homeTeamId:"GHA", awayTeamId:"PAN", matchday:1, date:"2026-06-17", kickoff:"2026-06-17T23:00:00Z", venue:"BMO Field, Toronto",                    isFinished:false }, // MD1 7pm ET ✅
  { id:"L-3", groupId:"L", homeTeamId:"ENG", awayTeamId:"GHA", matchday:2, date:"2026-06-24", kickoff:"2026-06-24T22:00:00Z", venue:"Lumen Field, Seattle",                  isFinished:false }, // MD2 6pm ET ✅
  { id:"L-4", groupId:"L", homeTeamId:"CRO", awayTeamId:"PAN", matchday:2, date:"2026-06-25", kickoff:"2026-06-25T01:00:00Z", venue:"Gillette Stadium, Foxborough",          isFinished:false }, // MD2 9pm ET ✅
  { id:"L-5", groupId:"L", homeTeamId:"ENG", awayTeamId:"PAN", matchday:3, date:"2026-06-27", kickoff:"2026-06-28T02:00:00Z", venue:"MetLife Stadium, New Jersey",           isFinished:false }, // MD3 10pm ET simultaneous
  { id:"L-6", groupId:"L", homeTeamId:"CRO", awayTeamId:"GHA", matchday:3, date:"2026-06-27", kickoff:"2026-06-28T02:00:00Z", venue:"Arrowhead Stadium, Kansas City",        isFinished:false }, // MD3 10pm ET simultaneous
];

export function getTeamById(id: string): WCTeam | undefined {
  return WC_TEAMS.find((t) => t.id === id);
}

export function getTeamsByGroup(group: string): WCTeam[] {
  return WC_TEAMS.filter((t) => t.group === group);
}

export function getMatchesByGroup(group: string): WCMatch[] {
  return WC_MATCHES.filter((m) => m.groupId === group);
}

export function getGroups() {
  return WC_GROUPS.map((g) => ({
    id: g,
    teams: getTeamsByGroup(g),
    matches: getMatchesByGroup(g),
  }));
}

/**
 * FIFA 2026 tiebreaker order within a group:
 * 1. Points
 * 2. Goal difference (all group matches)
 * 3. Goals scored (all group matches)
 * 4. Head-to-head points (among still-tied teams only)
 * 5. Head-to-head goal difference
 * 6. Head-to-head goals scored
 * 7. teamId alphabetical (deterministic fallback for prediction game)
 *
 * The algorithm clusters teams tied on pts/GD/GF and resolves each cluster
 * with a H2H mini-table, then falls back to teamId for any remaining ties.
 */
function applyFifaTiebreakers(
  teams: WCGroupStanding[],
  matches: WCMatch[],
  results: Record<string, "H" | "D" | "A">,
  actualScores?: Record<string, { home: number; away: number }>
): WCGroupStanding[] {
  // Primary sort: pts → GD → GF
  const primary = [...teams].sort((a, b) => {
    const gdA = a.goalsFor - a.goalsAgainst;
    const gdB = b.goalsFor - b.goalsAgainst;
    if (b.points !== a.points) return b.points - a.points;
    if (gdB !== gdA) return gdB - gdA;
    if (b.goalsFor !== a.goalsFor) return b.goalsFor - a.goalsFor;
    return 0;
  });

  // Split into clusters tied on (pts, GD, GF) and resolve each with H2H
  const result: WCGroupStanding[] = [];
  let i = 0;
  while (i < primary.length) {
    let j = i + 1;
    const ref = primary[i];
    const refGd = ref.goalsFor - ref.goalsAgainst;
    while (
      j < primary.length &&
      primary[j].points === ref.points &&
      (primary[j].goalsFor - primary[j].goalsAgainst) === refGd &&
      primary[j].goalsFor === ref.goalsFor
    ) j++;

    const cluster = primary.slice(i, j);
    if (cluster.length === 1) {
      result.push(cluster[0]);
    } else {
      // Compute H2H mini-table among cluster members
      const clusterIds = new Set(cluster.map((t) => t.teamId));
      const h2h: Record<string, { pts: number; gd: number; gf: number }> = {};
      for (const t of cluster) h2h[t.teamId] = { pts: 0, gd: 0, gf: 0 };

      for (const match of matches) {
        if (!clusterIds.has(match.homeTeamId) || !clusterIds.has(match.awayTeamId)) continue;
        const r = results[match.id];
        if (!r) continue;
        const real = actualScores?.[match.id];
        let hg: number, ag: number;
        if (r === "H") { hg = real?.home ?? 2; ag = real?.away ?? 0; }
        else if (r === "D") { hg = real?.home ?? 1; ag = real?.away ?? 1; }
        else { hg = real?.home ?? 0; ag = real?.away ?? 2; }

        if (r === "H") h2h[match.homeTeamId].pts += 3;
        else if (r === "D") { h2h[match.homeTeamId].pts += 1; h2h[match.awayTeamId].pts += 1; }
        else h2h[match.awayTeamId].pts += 3;
        h2h[match.homeTeamId].gf += hg; h2h[match.homeTeamId].gd += hg - ag;
        h2h[match.awayTeamId].gf += ag; h2h[match.awayTeamId].gd += ag - hg;
      }

      cluster.sort((a, b) => {
        const ha = h2h[a.teamId], hb = h2h[b.teamId];
        if (hb.pts !== ha.pts) return hb.pts - ha.pts;
        if (hb.gd !== ha.gd) return hb.gd - ha.gd;
        if (hb.gf !== ha.gf) return hb.gf - ha.gf;
        return a.teamId.localeCompare(b.teamId);
      });
      result.push(...cluster);
    }
    i = j;
  }
  return result;
}

/**
 * Simulates group standings from match results (H/D/A) and optional actual scores.
 *
 * @param groupId       Group letter (A-L)
 * @param results       Map of matchId → "H" | "D" | "A"  (required; used for points/W/D/L)
 * @param actualScores  Map of matchId → { home, away } goals.  When provided, these real
 *                      goal figures are used for GD/GF tiebreakers instead of the synthetic
 *                      2-0 / 1-1 defaults.  Pass undefined for prediction simulation.
 */
export function simulateGroupStandings(
  groupId: string,
  results: Record<string, "H" | "D" | "A">,
  actualScores?: Record<string, { home: number; away: number }>
): WCGroupStanding[] {
  const teams = getTeamsByGroup(groupId);
  const matches = getMatchesByGroup(groupId);
  const standings: Record<string, WCGroupStanding> = {};
  for (const t of teams) {
    standings[t.id] = { teamId: t.id, played: 0, won: 0, drawn: 0, lost: 0, goalsFor: 0, goalsAgainst: 0, gd: 0, points: 0, position: 0 };
  }
  for (const match of matches) {
    const result = results[match.id];
    if (!result) continue;
    const home = standings[match.homeTeamId];
    const away = standings[match.awayTeamId];
    if (!home || !away) continue;
    home.played++;
    away.played++;

    const realScore = actualScores?.[match.id];
    if (result === "H") {
      home.won++; away.lost++;
      home.points += 3;
      const hg = realScore?.home ?? 2;
      const ag = realScore?.away ?? 0;
      home.goalsFor += hg; away.goalsFor += ag;
      home.goalsAgainst += ag; away.goalsAgainst += hg;
    } else if (result === "D") {
      home.drawn++; away.drawn++;
      home.points += 1; away.points += 1;
      const hg = realScore?.home ?? 1;
      const ag = realScore?.away ?? 1;
      home.goalsFor += hg; away.goalsFor += ag;
      home.goalsAgainst += ag; away.goalsAgainst += hg;
    } else {
      away.won++; home.lost++;
      away.points += 3;
      const hg = realScore?.home ?? 0;
      const ag = realScore?.away ?? 2;
      home.goalsFor += hg; away.goalsFor += ag;
      home.goalsAgainst += ag; away.goalsAgainst += hg;
    }
  }

  const sorted = applyFifaTiebreakers(Object.values(standings), matches, results, actualScores);
  return sorted.map((s, i) => ({ ...s, gd: s.goalsFor - s.goalsAgainst, position: i + 1 }));
}

export const BASE_POINTS: Record<string, number> = {
  R32: 2,
  R16: 4,
  QF: 8,
  SF: 16,
  THIRD: 8,
  FINAL: 32,
};

export function scoreKnockoutPick(
  round: string,
  pickedTeamId: string,
  actualWinner: string,
  _totalPoolMembers?: number,
  _membersWhoPicked?: number
): number {
  if (pickedTeamId !== actualWinner) return 0;
  return BASE_POINTS[round] ?? 2;
}

export function getBonusPickPoints(round: string, pickType: "clean_sheet" | "exact_score" | "penalties"): number {
  const base = BASE_POINTS[round] ?? 2;
  if (pickType === "clean_sheet") return Math.round(base * 0.5);
  if (pickType === "penalties") return Math.round(base * 0.75);
  return base;
}

export const WILDCARD_TYPES = [
  { id: "tournament_winner", label: "Tournament Winner", points: 25 },
  { id: "golden_boot", label: "Golden Boot — Top Scorer", points: 15 },
  { id: "dark_horse_qf", label: "Dark Horse to QF+ (outside FIFA top 20)", points: 12 },
  { id: "exact_final_score", label: "Exact Final Scoreline", points: 20 },
  { id: "total_goals_final", label: "Total Goals in Final (tiebreaker)", points: 0 },
] as const;

export const KNOCKOUT_ROUNDS = [
  { id: "R32",   label: "Round of 32",    basePoints: 2,  firstMatchTime: "2026-06-28T19:00:00Z" },
  { id: "R16",   label: "Round of 16",    basePoints: 4,  firstMatchTime: "2026-07-04T17:00:00Z" },
  { id: "QF",    label: "Quarterfinals",  basePoints: 8,  firstMatchTime: "2026-07-09T19:00:00Z" },
  { id: "SF",    label: "Semifinals",     basePoints: 16, firstMatchTime: "2026-07-14T19:00:00Z" },
  { id: "THIRD", label: "3rd Place Match",basePoints: 8,  firstMatchTime: "2026-07-18T19:00:00Z" },
  { id: "FINAL", label: "Final / Champion",basePoints: 32, firstMatchTime: "2026-07-19T19:00:00Z" },
];

export function isRoundLocked(round: string): boolean {
  const roundDef = KNOCKOUT_ROUNDS.find((r) => r.id === round);
  if (!roundDef) return true;
  const lockTime = new Date(roundDef.firstMatchTime).getTime() - 30 * 60 * 1000;
  return Date.now() >= lockTime;
}

export function getRoundLockTime(round: string): Date | null {
  const roundDef = KNOCKOUT_ROUNDS.find((r) => r.id === round);
  if (!roundDef) return null;
  return new Date(new Date(roundDef.firstMatchTime).getTime() - 30 * 60 * 1000);
}

export const PHASE1_LOCK_DATE = new Date("2026-06-11T17:00:00Z");
export const PHASE2_UNLOCK_DATE = new Date("2026-06-28T00:00:00Z");

export function isPhase1Locked(): boolean {
  return new Date() >= PHASE1_LOCK_DATE;
}

export function isPhase2Unlocked(): boolean {
  return new Date() >= PHASE2_UNLOCK_DATE;
}

export interface GroupPickScore {
  totalPoints: number;
  correctResults: number;
  correctPositions: number;
  perfectGroupBonus: number;
  bestMatchId?: string;
  bestMatchPoints: number;
}

/**
 * Phase 1 scoring table:
 *   Correct match result:      +2 pts each
 *   Correct group winner (1st): +4 pts
 *   Correct runner-up (2nd):   +3 pts
 *   Correct 3rd place:         +2 pts
 *   Correct 4th place:         +1 pt
 *   Perfect group (all 4):     +5 bonus pts
 */
export function scoreGroupPicks(
  userPicks: Record<string, "H" | "D" | "A">,
  actualResults: Record<string, "H" | "D" | "A">,
  actualStandings: Record<string, WCGroupStanding[]>
): GroupPickScore {
  let totalPoints = 0;
  let correctResults = 0;
  let correctPositions = 0;
  let perfectGroupBonus = 0;
  let bestMatchPoints = 0;
  let bestMatchId: string | undefined;

  for (const [matchId, predicted] of Object.entries(userPicks)) {
    const actual = actualResults[matchId];
    if (!actual) continue;
    if (predicted === actual) {
      correctResults++;
      totalPoints += 2;
      if (2 > bestMatchPoints) { bestMatchPoints = 2; bestMatchId = matchId; }
    }
  }

  for (const [groupId, actualGroupStandings] of Object.entries(actualStandings)) {
    if (!actualGroupStandings || actualGroupStandings.length === 0) continue;

    const groupPickResults = Object.fromEntries(
      Object.entries(userPicks).filter(([k]) => k.startsWith(groupId + "-"))
    ) as Record<string, "H" | "D" | "A">;
    const userStandings = simulateGroupStandings(groupId, groupPickResults);

    const POS_POINTS: Record<number, number> = { 1: 4, 2: 3, 3: 2, 4: 1 };
    let groupPositionsCorrect = 0;

    for (let pos = 1; pos <= 4; pos++) {
      const actualTeam = actualGroupStandings.find((s) => s.position === pos)?.teamId;
      const userTeam = userStandings.find((s) => s.position === pos)?.teamId;
      if (actualTeam && userTeam && actualTeam === userTeam) {
        correctPositions++;
        groupPositionsCorrect++;
        const posBonus = POS_POINTS[pos] ?? 0;
        totalPoints += posBonus;
        if (posBonus > bestMatchPoints) { bestMatchPoints = posBonus; bestMatchId = `${groupId}-pos${pos}`; }
      }
    }

    if (groupPositionsCorrect === 4) {
      perfectGroupBonus++;
      totalPoints += 5;
    }
  }

  return { totalPoints, correctResults, correctPositions, perfectGroupBonus, bestMatchId, bestMatchPoints };
}

/**
 * Returns all 3rd-place finishers from the specified groups, sorted best→worst
 * by pts / GD / GF so callers can pick the top-N best-of-thirds.
 */
function getBestThirdTeams(
  groupStandings: Record<string, WCGroupStanding[]>,
  fromGroups?: string[]
): string[] {
  const groups = fromGroups ?? Object.keys(groupStandings);
  const thirds: WCGroupStanding[] = [];
  for (const g of groups) {
    const third = groupStandings[g]?.find((s) => s.position === 3);
    if (third) thirds.push(third);
  }
  thirds.sort((a, b) =>
    b.points !== a.points ? b.points - a.points :
    b.gd !== a.gd ? b.gd - a.gd :
    b.goalsFor - a.goalsFor
  );
  return thirds.map((s) => s.teamId);
}

/**
 * Resolves bracket matchups using group standings + prior round winners.
 * Supports descriptors: "1A", "2C", "Best 3rd (A/B/C/D/F)", "W(R32-1)", "L(SF-1)"
 *
 * Multi-pass: each pass propagates one round further until no new slots resolve.
 *
 * Best-third deduplication uses a constrained-first bipartite matching:
 *   1. Build globally-ranked list of all 3rd-place teams.
 *   2. Find every "Best 3rd" slot and the groups it is eligible to draw from.
 *   3. Sort slots by how many qualifying groups they can draw from (ascending
 *      = most constrained first), so tightly-constrained slots are served before
 *      slots with more flexibility.  This prevents a flexible slot from "stealing"
 *      the only team available to a constrained slot.
 *   4. Greedy assignment: for each slot (in constrained order), pick the globally
 *      highest-ranked 3rd whose group hasn't been assigned yet and is eligible for
 *      this slot.
 * The pre-computed assignment map is keyed by `${slotId}_${side}` and is read in
 * the descriptor resolver — it has no mutable side-effects during the multi-pass
 * resolution loop, so there are no double-consumption bugs.
 */
export function getKnockoutMatchups(
  groupStandings: Record<string, WCGroupStanding[]>,
  knockoutWinners: Record<string, string> = {}
): Record<string, { homeTeamId?: string; awayTeamId?: string }> {
  const resolved: Record<string, { homeTeamId?: string; awayTeamId?: string }> = {};
  const slotWinners: Record<string, string> = { ...knockoutWinners };

  // ── Step 1: Globally-ranked 3rd-place list with group labels ─────────────
  const allThirds: Array<WCGroupStanding & { group: string }> = [];
  for (const g of Object.keys(groupStandings)) {
    const third = groupStandings[g]?.find((s) => s.position === 3);
    if (third) allThirds.push({ ...third, group: g });
  }
  allThirds.sort((a, b) =>
    b.points !== a.points ? b.points - a.points :
    b.gd !== a.gd ? b.gd - a.gd :
    b.goalsFor !== a.goalsFor ? b.goalsFor - a.goalsFor :
    a.teamId.localeCompare(b.teamId)
  );

  // ── Step 2: Enumerate "Best 3rd" slots and their eligible group lists ─────
  type BestThirdSlotInfo = { slotId: string; side: "home" | "away"; groupList: string[] };
  const bestThirdSlots: BestThirdSlotInfo[] = [];
  for (const slotDef of WC_BRACKET_SLOTS) {
    for (const side of ["home", "away"] as const) {
      const desc = side === "home" ? slotDef.homeSlotDesc : slotDef.awaySlotDesc;
      if (!desc) continue;
      const m = desc.match(/Best\s+3rd\s+\(([A-L/,\s]+)\)/i);
      if (!m) continue;
      const groupList = m[1].split(/[/,\s]+/).map((g) => g.trim().toUpperCase()).filter(Boolean);
      bestThirdSlots.push({ slotId: slotDef.slot, side, groupList });
    }
  }

  // ── Step 3: Sort by most constrained first (fewest qualifying groups) ─────
  const qualifyingGroups = new Set(allThirds.map((t) => t.group));
  bestThirdSlots.sort((a, b) => {
    const aq = a.groupList.filter((g) => qualifyingGroups.has(g)).length;
    const bq = b.groupList.filter((g) => qualifyingGroups.has(g)).length;
    if (aq !== bq) return aq - bq;
    // Secondary: bracket order (index in WC_BRACKET_SLOTS)
    const ai = WC_BRACKET_SLOTS.findIndex((s) => s.slot === a.slotId);
    const bi = WC_BRACKET_SLOTS.findIndex((s) => s.slot === b.slotId);
    return ai - bi;
  });

  // ── Step 4: Constrained-first greedy assignment ───────────────────────────
  const assignedGroups = new Set<string>();
  const bestThirdMap = new Map<string, string>(); // `${slotId}_${side}` → teamId
  for (const slot of bestThirdSlots) {
    for (const candidate of allThirds) {
      if (assignedGroups.has(candidate.group)) continue;
      if (!slot.groupList.includes(candidate.group)) continue;
      assignedGroups.add(candidate.group);
      bestThirdMap.set(`${slot.slotId}_${slot.side}`, candidate.teamId);
      break;
    }
  }

  // ── Descriptor resolver ───────────────────────────────────────────────────
  function resolveDesc(desc: string, slotId: string, side: "home" | "away"): string | undefined {
    const posGroupMatch = desc.match(/^(\d)([A-L])$/);
    if (posGroupMatch) {
      const pos = parseInt(posGroupMatch[1]);
      const g = posGroupMatch[2].toUpperCase();
      return groupStandings[g]?.find((s) => s.position === pos)?.teamId;
    }

    // All "Best 3rd" variants are resolved from the pre-computed map
    if (/Best\s+3rd/i.test(desc)) {
      return bestThirdMap.get(`${slotId}_${side}`);
    }

    const winnerMatch = desc.match(/^W\(([A-Z0-9-]+)\)$/);
    if (winnerMatch) return slotWinners[winnerMatch[1]];

    const loserMatch = desc.match(/^L\(([A-Z0-9-]+)\)$/);
    if (loserMatch) {
      const sfSlot = resolved[loserMatch[1]];
      const winner = slotWinners[loserMatch[1]];
      if (sfSlot && winner) {
        return sfSlot.homeTeamId === winner ? sfSlot.awayTeamId : sfSlot.homeTeamId;
      }
    }

    return undefined;
  }

  // ── Multi-pass resolution ─────────────────────────────────────────────────
  let prevSize = -1;
  for (let pass = 0; pass < WC_BRACKET_SLOTS.length && Object.keys(resolved).length !== prevSize; pass++) {
    prevSize = Object.keys(resolved).length;
    for (const slot of WC_BRACKET_SLOTS) {
      const existing = resolved[slot.slot];
      if (existing?.homeTeamId && existing?.awayTeamId) continue;
      // Preserve already-resolved sides — avoids re-invoking resolveDesc for slots
      // that were partially resolved in a prior pass.
      const homeTeamId = slot.homeTeamId ?? existing?.homeTeamId ?? resolveDesc(slot.homeSlotDesc, slot.slot, "home");
      const awayTeamId = slot.awayTeamId ?? existing?.awayTeamId ?? resolveDesc(slot.awaySlotDesc, slot.slot, "away");
      if (homeTeamId || awayTeamId) {
        resolved[slot.slot] = { homeTeamId, awayTeamId };
        if (homeTeamId && awayTeamId && knockoutWinners[slot.slot]) {
          slotWinners[slot.slot] = knockoutWinners[slot.slot];
        }
      }
    }
  }

  return resolved;
}

export const WC_ACTUAL_RESULTS: Record<string, "H" | "D" | "A"> = {};

export function getMatches(group?: string): WCMatch[] {
  if (group) return WC_MATCHES.filter((m) => m.groupId === group);
  return WC_MATCHES;
}

export function getStandings(group: string, liveResults?: Record<string, "H" | "D" | "A">): WCGroupStanding[] {
  return simulateGroupStandings(group, liveResults ?? {});
}

// FIFA rankings for all 48 qualified teams (approximate April 2025 ranking).
const FIFA_RANKINGS: Record<string, number> = {
  ARG: 1,  FRA: 2,  BEL: 3,  ENG: 4,  BRA: 5,
  POR: 6,  ESP: 6,  NED: 7,  GER: 9,  CRO: 10,
  USA: 11, MAR: 14, JPN: 17, MEX: 15, URU: 18,
  SUI: 19, SEN: 20, KOR: 22, IRN: 22, AUS: 23,
  SWE: 24, AUT: 25, COL: 25, TUR: 26, SCO: 30,
  NOR: 34, TUN: 30, CZE: 37, QAT: 37, EGY: 38,
  CAN: 47, CIV: 48, ALG: 50, BIH: 55, COD: 56,
  IRQ: 56, SAU: 57, PAR: 60, GHA: 60, RSA: 63,
  UZB: 70, CPV: 78, PAN: 80, JOR: 85, ECU: 44,
  HAI: 91, CUW: 88, NZL: 99,
};

export function getFIFARanking(teamId: string): number {
  return FIFA_RANKINGS[teamId] ?? 99;
}

export const ACTUAL_WILDCARD_ANSWERS: Record<string, string> = {};

export type BracketRound = "R32" | "R16" | "QF" | "SF" | "THIRD" | "FINAL";

export interface BracketSlot {
  slot: string;
  round: BracketRound;
  homeSlotDesc: string;
  awaySlotDesc: string;
  homeTeamId?: string;
  awayTeamId?: string;
  actualWinnerId?: string;
  feedsIntoSlot?: string;
  kickoffTime?: string; // ISO UTC — used for per-match bonus-pick lock (kickoff - 30 min)
}

/**
 * Returns true if this specific match's bonus-pick window is closed.
 * Lock triggers 30 minutes before the individual match kickoff.
 * Falls back to the round's firstMatchTime when no per-slot time is set.
 */
export function isMatchLocked(matchSlot: string): boolean {
  const slot = WC_BRACKET_SLOTS.find((s) => s.slot === matchSlot);
  if (!slot) return true;
  const cutoffISO = slot.kickoffTime ?? KNOCKOUT_ROUNDS.find((r) => r.id === slot.round)?.firstMatchTime;
  if (!cutoffISO) return true;
  return Date.now() >= new Date(cutoffISO).getTime() - 30 * 60 * 1000;
}

export function getMatchLockTime(matchSlot: string): Date | null {
  const slot = WC_BRACKET_SLOTS.find((s) => s.slot === matchSlot);
  if (!slot) return null;
  const cutoffISO = slot.kickoffTime ?? KNOCKOUT_ROUNDS.find((r) => r.id === slot.round)?.firstMatchTime;
  if (!cutoffISO) return null;
  return new Date(new Date(cutoffISO).getTime() - 30 * 60 * 1000);
}

export const WC_BRACKET_SLOTS: BracketSlot[] = [
  // ── ROUND OF 32 ───────────────────────────────────────────────────────────
  // Official FIFA bracket per match numbers M73–M88 (kickoff times = UTC)
  // Jun 28
  { slot: "R32-1",  round: "R32", homeSlotDesc: "2A", awaySlotDesc: "2B",               feedsIntoSlot: "R16-2", kickoffTime: "2026-06-28T19:00:00Z" }, // M73  SoFi, Inglewood CA
  // Jun 29
  { slot: "R32-2",  round: "R32", homeSlotDesc: "1C", awaySlotDesc: "2F",               feedsIntoSlot: "R16-1", kickoffTime: "2026-06-29T17:00:00Z" }, // M74  NRG, Houston TX
  { slot: "R32-3",  round: "R32", homeSlotDesc: "1E", awaySlotDesc: "Best 3rd (A/B/C/D/F)", feedsIntoSlot: "R16-3", kickoffTime: "2026-06-29T20:30:00Z" }, // M76  Gillette, Foxborough MA
  { slot: "R32-4",  round: "R32", homeSlotDesc: "1F", awaySlotDesc: "2C",               feedsIntoSlot: "R16-2", kickoffTime: "2026-06-30T01:00:00Z" }, // M75  Estadio BBVA, Guadalupe MX
  // Jun 30
  { slot: "R32-5",  round: "R32", homeSlotDesc: "2E", awaySlotDesc: "2I",               feedsIntoSlot: "R16-3", kickoffTime: "2026-06-30T17:00:00Z" }, // M78  AT&T, Arlington TX
  { slot: "R32-6",  round: "R32", homeSlotDesc: "1I", awaySlotDesc: "Best 3rd (C/D/F/G/H)", feedsIntoSlot: "R16-4", kickoffTime: "2026-06-30T21:00:00Z" }, // M79  MetLife, E. Rutherford NJ
  { slot: "R32-7",  round: "R32", homeSlotDesc: "1A", awaySlotDesc: "Best 3rd (C/E/F/H/I)", feedsIntoSlot: "R16-1", kickoffTime: "2026-07-01T01:00:00Z" }, // M77  Estadio Azteca, Mexico City MX
  // Jul 1
  { slot: "R32-8",  round: "R32", homeSlotDesc: "1L", awaySlotDesc: "Best 3rd (E/H/I/J/K)", feedsIntoSlot: "R16-4", kickoffTime: "2026-07-01T16:00:00Z" }, // M80  Mercedes-Benz, Atlanta GA
  { slot: "R32-9",  round: "R32", homeSlotDesc: "1G", awaySlotDesc: "Best 3rd (A/E/H/I/J)", feedsIntoSlot: "R16-6", kickoffTime: "2026-07-01T20:00:00Z" }, // M82  Lumen Field, Seattle WA
  { slot: "R32-10", round: "R32", homeSlotDesc: "1D", awaySlotDesc: "Best 3rd (B/E/F/I/J)", feedsIntoSlot: "R16-6", kickoffTime: "2026-07-02T00:00:00Z" }, // M81  Levi's, Santa Clara CA
  // Jul 2
  { slot: "R32-11", round: "R32", homeSlotDesc: "1H", awaySlotDesc: "2J",               feedsIntoSlot: "R16-5", kickoffTime: "2026-07-02T19:00:00Z" }, // M84  SoFi, Inglewood CA
  { slot: "R32-12", round: "R32", homeSlotDesc: "2K", awaySlotDesc: "2L",               feedsIntoSlot: "R16-5", kickoffTime: "2026-07-02T23:00:00Z" }, // M83  BMO Field, Toronto ON
  { slot: "R32-13", round: "R32", homeSlotDesc: "1B", awaySlotDesc: "Best 3rd (E/F/G/I/J)", feedsIntoSlot: "R16-8", kickoffTime: "2026-07-03T03:00:00Z" }, // M85  BC Place, Vancouver BC
  // Jul 3
  { slot: "R32-14", round: "R32", homeSlotDesc: "2D", awaySlotDesc: "2G",               feedsIntoSlot: "R16-7", kickoffTime: "2026-07-03T18:00:00Z" }, // M88  AT&T, Arlington TX
  { slot: "R32-15", round: "R32", homeSlotDesc: "1J", awaySlotDesc: "2H",               feedsIntoSlot: "R16-7", kickoffTime: "2026-07-03T22:00:00Z" }, // M86  Hard Rock, Miami FL
  { slot: "R32-16", round: "R32", homeSlotDesc: "1K", awaySlotDesc: "Best 3rd (D/E/I/J/L)", feedsIntoSlot: "R16-8", kickoffTime: "2026-07-04T01:30:00Z" }, // M87  Arrowhead, Kansas City MO

  // ── ROUND OF 16 ───────────────────────────────────────────────────────────
  // M89–M96; each pairing is per official FIFA bracket (Annex C, fixed structure)
  { slot: "R16-1", round: "R16", homeSlotDesc: "W(R32-2)", awaySlotDesc: "W(R32-7)",  feedsIntoSlot: "QF-1", kickoffTime: "2026-07-04T21:00:00Z" }, // M89  Lincoln Financial, Philadelphia PA
  { slot: "R16-2", round: "R16", homeSlotDesc: "W(R32-1)", awaySlotDesc: "W(R32-4)",  feedsIntoSlot: "QF-1", kickoffTime: "2026-07-04T17:00:00Z" }, // M90  NRG, Houston TX
  { slot: "R16-3", round: "R16", homeSlotDesc: "W(R32-3)", awaySlotDesc: "W(R32-5)",  feedsIntoSlot: "QF-3", kickoffTime: "2026-07-05T20:00:00Z" }, // M91  MetLife, E. Rutherford NJ
  { slot: "R16-4", round: "R16", homeSlotDesc: "W(R32-6)", awaySlotDesc: "W(R32-8)",  feedsIntoSlot: "QF-3", kickoffTime: "2026-07-06T00:00:00Z" }, // M92  Estadio Azteca, Mexico City MX
  { slot: "R16-5", round: "R16", homeSlotDesc: "W(R32-12)", awaySlotDesc: "W(R32-11)", feedsIntoSlot: "QF-2", kickoffTime: "2026-07-06T19:00:00Z" }, // M93  AT&T, Dallas TX
  { slot: "R16-6", round: "R16", homeSlotDesc: "W(R32-10)", awaySlotDesc: "W(R32-9)", feedsIntoSlot: "QF-2", kickoffTime: "2026-07-07T00:00:00Z" }, // M94  Lumen Field, Seattle WA
  { slot: "R16-7", round: "R16", homeSlotDesc: "W(R32-15)", awaySlotDesc: "W(R32-14)", feedsIntoSlot: "QF-4", kickoffTime: "2026-07-07T16:00:00Z" }, // M95  Mercedes-Benz, Atlanta GA
  { slot: "R16-8", round: "R16", homeSlotDesc: "W(R32-13)", awaySlotDesc: "W(R32-16)", feedsIntoSlot: "QF-4", kickoffTime: "2026-07-07T20:00:00Z" }, // M96  BC Place, Vancouver BC

  // ── QUARTERFINALS ─────────────────────────────────────────────────────────
  // M97 Boston · M98 LA · M99 Miami · M100 Kansas City
  // QF-1 & QF-2 winners → SF-1 (Dallas); QF-3 & QF-4 winners → SF-2 (Atlanta)
  { slot: "QF-1", round: "QF", homeSlotDesc: "W(R16-1)", awaySlotDesc: "W(R16-2)", feedsIntoSlot: "SF-1", kickoffTime: "2026-07-09T19:00:00Z" }, // M97  Gillette, Foxborough MA
  { slot: "QF-2", round: "QF", homeSlotDesc: "W(R16-5)", awaySlotDesc: "W(R16-6)", feedsIntoSlot: "SF-1", kickoffTime: "2026-07-10T19:00:00Z" }, // M98  SoFi, Inglewood CA
  { slot: "QF-3", round: "QF", homeSlotDesc: "W(R16-3)", awaySlotDesc: "W(R16-4)", feedsIntoSlot: "SF-2", kickoffTime: "2026-07-11T19:00:00Z" }, // M99  Hard Rock, Miami FL
  { slot: "QF-4", round: "QF", homeSlotDesc: "W(R16-7)", awaySlotDesc: "W(R16-8)", feedsIntoSlot: "SF-2", kickoffTime: "2026-07-11T23:00:00Z" }, // M100 Arrowhead, Kansas City MO

  // ── SEMIFINALS ────────────────────────────────────────────────────────────
  { slot: "SF-1", round: "SF", homeSlotDesc: "W(QF-1)", awaySlotDesc: "W(QF-2)", feedsIntoSlot: "FINAL-1", kickoffTime: "2026-07-14T19:00:00Z" }, // AT&T, Dallas TX
  { slot: "SF-2", round: "SF", homeSlotDesc: "W(QF-3)", awaySlotDesc: "W(QF-4)", feedsIntoSlot: "FINAL-1", kickoffTime: "2026-07-15T19:00:00Z" }, // Mercedes-Benz, Atlanta GA

  // ── 3RD PLACE & FINAL ─────────────────────────────────────────────────────
  { slot: "THIRD-1", round: "THIRD", homeSlotDesc: "L(SF-1)", awaySlotDesc: "L(SF-2)", kickoffTime: "2026-07-18T19:00:00Z" }, // Hard Rock, Miami FL
  { slot: "FINAL-1", round: "FINAL", homeSlotDesc: "W(SF-1)", awaySlotDesc: "W(SF-2)", kickoffTime: "2026-07-19T19:00:00Z" }, // MetLife, East Rutherford NJ
];

export const WC_R32_BRACKET = WC_BRACKET_SLOTS.filter((s) => s.round === "R32");
